// Imports
import * as React from "react"
import { Helmet } from "react-helmet"
import { useLocation } from "@reach/router"
import { useSiteMetaData } from "@queries"

export const Seo = ({ pageData, ogImage }) => {
  const location = useLocation()

  const { title: siteDefaultTitle, description: siteDefaultDescription } =
    useSiteMetaData()

  const title = pageData?.title ? pageData.title : siteDefaultTitle
  const description = pageData?.articleBody
    ? pageData.articleBody[0].childContentfulArticleLeadLeadTextNode?.lead
    : pageData?.content.shortDescription.shortDescription
    ? pageData.content.shortDescription.shortDescription
    : siteDefaultDescription

  const validOGImage = ogImage ? ogImage.imagePath : "images/OG-Image-Template.png"

  // Construct the meta array for passing into react helmet.
  const metas = [
    {
      name: "title",
      content: title || siteDefaultTitle,
    },
    {
      name: "description",
      content: description || siteDefaultDescription,
    },
    {
      property: `image`,
      content: "https://envimap.netlify.app/" + validOGImage,
    },

    // Facebook
    {
      name: "og:type",
      content: "website",
    },
    {
      name: "og:url",
      content: location.href,
    },
    {
      name: "og:title",
      content: title,
    },
    {
      name: "og:description",
      content: description,
    },
    {
      name: "og:image",
      content: "https://envimap.netlify.app/" + validOGImage,
    },
    {
      name: "og:image:width",
      content: "400",
    },
    {
      name: "og:image:height",
      content: "50",
    },

    // Twitter
    {
      name: "twitter:card",
      content: "summary_large_image",
    },
    {
      name: "twitter:url",
      content: location.href,
    },
    {
      name: "twitter:title",
      content: title,
    },
    {
      name: "twitter:description",
      content: description,
    },
    {
      property: `twitter:image`,
      content: "https://envimap.netlify.app/" + validOGImage,
    },
  ]

  return (
    <Helmet>
      <title>{"Envimap | " + title || siteDefaultTitle}</title>
      {metas.map((meta, index) => (
        <meta key={meta.name + index} name={meta.name} content={meta.content} />
      ))}
    </Helmet>
  )
}
